import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-table-6/react-table.css";
import Loader from 'react-loader-spinner';


class BillingSetting extends Component {
    constructor() {
        super();
        this.state = {
            enterprise: false,
            stateNameList: [],
            countryNameList: [],
            fields: { countryName: { "name": "", "id": "" }, stateName: { "name": "", "value": "" } },
            showEditBtn: false,
            editable: true,
            hideDeletePopup: false,
            loadView: false
        }
        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteOrgDetailsAPi()
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

    }

    componentDidMount() {
        let thisComponent = this;
        setTimeout(() => {
            thisComponent.getCountryNames();
            thisComponent.fetchProjectBillingSettingApi();
        }, 500);

        document.addEventListener("projectChanged", function (event) {
            thisComponent.getCountryNames();
            thisComponent.projectId = event.projectId;
            thisComponent.fetchProjectBillingSettingApi(event.projectId);
        });
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    refreshData = () => {
        this.state.errors = {};
        this.setState(this.state);
        this.fetchProjectBillingSettingApi();
    }

    fetchProjectBillingSettingApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = { projectId: projectId }
        let billingSettingsComponent = this;
        billingSettingsComponent.state.loadView = false;
        $.ajax({
            url: "/api/project-billing-setting",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                billingSettingsComponent.state.loadView = true;
                if (res.success === true) {
                    billingSettingsComponent.state.fields = res.result.projectBillingSettings;
                    if (res.result.projectBillingSettings.countryId != null && res.result.projectBillingSettings.countryName != null) {
                        billingSettingsComponent.state.fields.countryName = { "id": res.result.projectBillingSettings.countryId, "name": res.result.projectBillingSettings.countryName };
                    }
                    if (res.result.stateName != null) {
                        billingSettingsComponent.state.fields.stateName = { "name": res.result.stateName.name, "value": res.result.stateName.value };
                    }
                    if (!res.result.enterprise) {
                        if (document.getElementById("companyName") != null && document.getElementById("companyName") != undefined) {
                            document.getElementById("companyName").value = "";
                            document.getElementById("companyWebsite").value = "";
                        }
                    }
                    if (document.getElementById("gstIn") != null) {
                        document.getElementById("gstIn").value = res.result.projectBillingSettings.gstIn;
                    }
                    billingSettingsComponent.state.enterprise = res.result.projectBillingSettings.enterprise;
                    billingSettingsComponent.state.editable = false;
                    billingSettingsComponent.state.showEditBtn = true;
                    billingSettingsComponent.setState(billingSettingsComponent.state);
                } else {
                    billingSettingsComponent.state.fields = { countryName: { "id": billingSettingsComponent.state.fields.countryName.id, "name": billingSettingsComponent.state.fields.countryName.name }, stateName: { "name": billingSettingsComponent.state.fields.stateName.name, "value": billingSettingsComponent.state.fields.stateName.value } };
                    if (document.getElementById("name") != null && document.getElementById("name") != undefined) {
                        document.getElementById("name").value = "";
                        document.getElementById("emailId").value = "";
                        document.getElementById("phoneNumber").value = "";
                        document.getElementById("panNumber").value = "";
                        document.getElementById("companyName").value = "";
                        document.getElementById("companyWebsite").value = "";
                        document.getElementById("billingAddress").value = "";
                        document.getElementById("gstIn").value = "";
                    }
                    billingSettingsComponent.state.enterprise = false;
                    billingSettingsComponent.state.editable = true;
                    billingSettingsComponent.state.showEditBtn = false;
                    billingSettingsComponent.setState(billingSettingsComponent.state);
                }
                billingSettingsComponent.fetchStateNamesApi();
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    NotifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateIsEnterpriseDetails = () => {
        var fields = this.state.fields;
        if (this.state.enterprise) {
            if (!fields["companyName"] || fields["companyName"].trim() == "") {
                this.notifyInvalidFields("Please fill all the fields")
                return false;
            } else if (!fields["companyWebsite"] || fields["companyWebsite"].trim() == "") {
                this.notifyInvalidFields("Please fill all the fields")
                return false;
            } else if (!fields["companyWebsite"].match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)) {
                this.notifyInvalidFields("Please enter valid company website")
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    saveDetails = () => {
        let billingSettingsComponent = this;
        if (billingSettingsComponent.validateBillingSetting() &&
            billingSettingsComponent.validateIsEnterpriseDetails()) {
            let data = billingSettingsComponent.state.fields;
            if (data["countryName"].name == "India") {
                data["stateName"] = billingSettingsComponent.state.fields.stateName.value;
            } else {
                let state = { ...this.state };
                delete state.fields.stateName;
                billingSettingsComponent.setState(state);
            }
            if (data["gstIn"] == undefined || data["gstIn"] == null || data["gstIn"] == "") {
                let state = { ...this.state };
                delete state.fields.gstIn;
                billingSettingsComponent.setState(state);
            }
            let country = billingSettingsComponent.state.fields.countryName.name;
            let countryId = billingSettingsComponent.state.fields.countryName.id;
            data["projectId"] = localStorage.getItem("currentProjectId");
            data["countryName"] = country;
            data["countryId"] = countryId;
            data["enterprise"] = billingSettingsComponent.state.enterprise;
            $.ajax({
                url: "/api/project-billing-setting",
                type: 'PATCH',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(data),
                success: function (res) {
                    if (res.success === true) {
                        billingSettingsComponent.notifySuccessToast("Project Billing Settings Updated Successfully");
                        billingSettingsComponent.fetchProjectBillingSettingApi();
                        billingSettingsComponent.setState(billingSettingsComponent.state);
                    } else {
                        billingSettingsComponent.NotifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    validateBillingSetting = () => {
        let fields = this.state.fields;
        let formIsValid = true;
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        const numberRegex = /^[0-9\b]+$/;

        if (!fields["name"] || fields["name"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            formIsValid = false;
        } else if (!fields["emailId"] || fields["emailId"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!pattern.test(fields["emailId"])) {
            this.notifyInvalidFields("Please enter valid email address");
            return false;
        } else if (!fields["phoneNumber"] || fields["phoneNumber"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!numberRegex.test(fields["phoneNumber"])) {
            this.notifyInvalidFields("Please enter valid phone number")
            return false;
        } else if (!fields["billingAddress"] || fields["billingAddress"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (fields["gstIn"] != undefined && fields["gstIn"].trim() != "" &&
            !fields["gstIn"].match(/^(\d){2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/)) {
            this.notifyInvalidFields("Please enter valid gstIn");
            return false;
        } else if (!fields["panNumber"] || fields["panNumber"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!fields["panNumber"].match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
            this.notifyInvalidFields("Please enter valid pan number")
            return false;
        } else {
            return true;
        }
    }

    deleteOrgDetailsAPi = () => {
        let billingSettingsComponent = this;
        $.ajax({
            url: "/api/project-billing-setting/" + billingSettingsComponent.state.fields.id,
            async: false,
            method: 'DELETE',
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },

            success: function (res) {
                if (res.success === true) {
                    billingSettingsComponent.setState({ hideDeletePopup: false });
                    billingSettingsComponent.notifySuccessToast("Deleted Successfully");
                    billingSettingsComponent.fetchProjectBillingSettingApi();
                } else {
                    billingSettingsComponent.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    editOrgDetails = () => {
        this.state.editable = true;
        this.state.showEditBtn = false;
        this.setState(this.state);
    }

    handleCheck = (e) => {
        var billingSettingComponent = this;
        if (e.target.id === "personal") {
            billingSettingComponent.state.enterprise = false;
        } else {
            billingSettingComponent.state.enterprise = true;
        }
        billingSettingComponent.setState(billingSettingComponent.state);
    }

    fetchStateNamesApi = () => {
        let billingSettingsComponent = this;
        billingSettingsComponent.state.loadView = false;
        billingSettingsComponent.state.stateNameList = [];
        $.ajax({
            url: "/api/state-names",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                billingSettingsComponent.state.loadView = true;
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        billingSettingsComponent.state.stateNameList.push(
                            { "name": res.result[i].name, "value": res.result[i].value });
                    }
                    if (billingSettingsComponent.state.fields.stateName.name == "") {
                        billingSettingsComponent.state.fields.stateName = { "name": res.result[0].name, "value": res.result[0].value };
                    }
                    billingSettingsComponent.setState(billingSettingsComponent.state);
                } else {
                    billingSettingsComponent.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    getCountryNames = () => {
        let billingSettingsComponent = this;
        billingSettingsComponent.state.loadView = false;
        billingSettingsComponent.state.countryNameList = [];
        $.ajax({
            url: "/api/country-names",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            success: function (res) {
                billingSettingsComponent.state.loadView = true;
                if (res.success === true) {
                    for (var i = 0; i < res.result.length; i++) {
                        billingSettingsComponent.state.countryNameList.push(
                            { "id": res.result[i].id, "name": res.result[i].name });
                        if (res.result[i].name == "India") {
                            billingSettingsComponent.state.fields.countryName = { "id": res.result[i].id, "name": res.result[i].name };
                        }
                    }
                    billingSettingsComponent.setState(billingSettingsComponent.state);
                } else {
                    billingSettingsComponent.NotifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    handleChangeCountry = (e) => {
        this.state.fields.countryName = { "name": e.target.options[e.target.selectedIndex].text, "id": e.target.value };
        this.setState(this.state);
        if (this.state.fields.countryName.name == "India") {
            this.fetchStateNamesApi();
        }
    }

    handleChangeState = (e) => {
        this.state.fields.stateName = { "name": e.target.options[e.target.selectedIndex].text, "value": e.target.value };
        this.setState(this.state);
    }

    render() {
        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.loadView}
                    height={300}
                    width={50}

                    timeout={3000}
                    style={{ textAlign: 'center' }} />
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                {/* for Combobox styling */}
                <link rel="stylesheet" href="./assets/css/combobox-style.css" />

                < ToastContainer className="Toast-at-center" />
                <div className="wrapper" style={{ display: this.state.loadView ? 'block' : 'none', marginTop: '-20px' }}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '30px' }}>Project Billing Settings</h6>
                            </div>
                            <div className="d-flex flex-row-reverse pt-2 col-sm-5">
                                <button className="btn action-button" style={{ marginTop: "6px" }}
                                    title="Refresh" onClick={this.refreshData}>
                                    <img src="./assets/images/refresh_white_24dp.png" />
                                </button>
                                <button type="button" className="btn action-button" onClick={this.editOrgDetails}
                                    style={{
                                        marginTop: '6px',
                                        display: this.state.showEditBtn ? 'block' : 'none'
                                    }}>
                                    <img className="img-responsive cursor-change" src="./assets/images/editWithWhiteFilled.png" />
                                </button>
                                <button type="button" className="btn action-button"
                                    style={{
                                        marginTop: '6px',
                                        display: this.state.showEditBtn ? 'none' : 'block'
                                    }} onClick={this.saveDetails}>Save</button>

                            </div>
                        </div>
                        {/* /.card-header */}

                        <div className="card-body p-0 mb-25">
                            <div className="tab-content col-12 p-0">
                                <div className="card card-primary mt-3">
                                    <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                                        <div className="col-sm-12" style={{ marginTop: "10px", marginBottom: '50px' }}>
                                            <div className="col-sm-6">
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Contact Name:</div>
                                                    <input className="col-sm-8"
                                                        type="text"
                                                        name="name" id="name" placeholder="Enter Authorised Person Name"
                                                        disabled={!this.state.editable}
                                                        value={this.state.fields.name}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Contact Number:</div>
                                                    <input
                                                        type="text" className="col-sm-8"
                                                        name="phoneNumber" id="phoneNumber" placeholder="Enter Authorised Person Phone Number"
                                                        value={this.state.fields.phoneNumber}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Billing Address:</div>
                                                    <input className="col-sm-8"
                                                        type="text" id="billingAddress"
                                                        name="billingAddress" placeholder="Enter Billing Address"
                                                        value={this.state.fields.billingAddress}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <input type="radio" id="personal" name="enterprise" value={false}
                                                        onChange={this.handleCheck} checked={!this.state.enterprise}
                                                        disabled={!this.state.editable} style={{ marginLeft: '6px' }}
                                                    />&nbsp;&nbsp;Personal
                                                    <input type="radio" id="enterprise" name="enterprise" value={true} onChange={this.handleCheck}
                                                        style={{ marginLeft: '40px' }} checked={this.state.enterprise}
                                                        disabled={!this.state.editable}
                                                    />&nbsp;&nbsp;Enterprise
                                                </div>
                                                <div className="row" style={{ display: this.state.enterprise ? 'block' : 'none', marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Company Name:</div>
                                                    <input
                                                        type="text" id="companyName" className="col-sm-8"
                                                        name="companyName" placeholder="Enter Company Name"
                                                        disabled={!this.state.editable}
                                                        value={this.state.fields.companyName}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>GSTIN:</div>
                                                    <input
                                                        type="text" id="gstIn" className="col-sm-8"
                                                        name="gstIn" placeholder={this.state.showEditBtn ? "" : "Enter Goods and Services Tax Identification Number(Optional)"}
                                                        value={this.state.fields.gstIn}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-6">
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>EmailID:</div>
                                                    <input
                                                        type="email" id="emailId" className="col-sm-8"
                                                        name="emailId" placeholder="Enter Authorised Person EmailId"
                                                        disabled={!this.state.editable}
                                                        value={this.state.fields.emailId}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Country:</div>
                                                    <select className="col-sm-8"
                                                        disabled={!this.state.editable}
                                                        value={this.state.fields.countryName.id}
                                                        name="countryName"
                                                        id="countryName"
                                                        style={{
                                                            padding: '0.375rem 0.75rem', background: 'white',
                                                            borderBlockColor: 'rgb(178, 178, 178)', borderRadius: '5px', height: "32px"
                                                        }}
                                                        onChange={this.handleChangeCountry}
                                                    >{this.state.countryNameList.map((countryName) =>
                                                        <option value={countryName.id}>{countryName.name}</option>
                                                    )}
                                                    </select>
                                                </div>
                                                <div className="row" style={{
                                                    display: this.state.fields.countryName.name == "India" ? 'flex' : 'none',
                                                    marginTop: '20px'
                                                }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>State Name<br />(GST jurisdiction):</div>
                                                    <select className="col-sm-8"
                                                        disabled={!this.state.editable}
                                                        name="stateName"
                                                        id="stateName"
                                                        value={this.state.fields.stateName.value}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', background: 'white',
                                                            borderBlockColor: 'rgb(178, 178, 178)', borderRadius: '5px', height: "32px"
                                                        }}
                                                        onChange={this.handleChangeState}
                                                    >{this.state.stateNameList.map((stateName) =>
                                                        <option value={stateName.value}>{stateName.name}</option>)}</select>
                                                </div>
                                                <div className="row" style={{
                                                    display: this.state.fields.countryName.name == "India" ? 'none' : 'flex',
                                                    marginTop: '40px'
                                                }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}></div>
                                                    <div className="col-sm-8" />
                                                </div>
                                                <div style={{ height: '60px' }}></div>
                                                <div className="row"
                                                    style={{ display: this.state.enterprise ? 'block' : 'none', marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Company Website:</div>
                                                    <input
                                                        type="text" id="companyWebsite" className="col-sm-8"
                                                        name="companyWebsite" placeholder="Enter Company Website"
                                                        value={this.state.fields.companyWebsite}
                                                        disabled={!this.state.editable}
                                                        onChange={this.handleChange}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                                <div className="row" style={{ marginTop: '20px' }}>
                                                    <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>PAN:</div>
                                                    <input
                                                        type="text" id="panNumber" className="col-sm-8"
                                                        name="panNumber" placeholder="Enter PAN Card Number"
                                                        value={this.state.fields.panNumber}
                                                        onChange={this.handleChange}
                                                        disabled={!this.state.editable}
                                                        style={{
                                                            padding: '0.375rem 0.75rem', textAlign: 'left',
                                                            borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                        }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <DialogComponent width='400px' style={{ marginTop: "150px", position: "fixed" }} animationSettings={this.settings}
                                header='Project Billing Settings' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                        </div>
                    </div>
                </div >
            </div>
        );
    }
}
export default BillingSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/BillingSetting.js